import { api } from '@marketplace-web/core-api/core-api-client-util'

type ToggleUserFollowArgs = {
  userId: number
}

type ToggleUserFollowResp = {
  is_followed: boolean
}

export const toggleUserFollow = ({ userId }: ToggleUserFollowArgs) =>
  api.post<ToggleUserFollowResp>('/followed_users/toggle', { user_id: userId })
